export default {
	MOBILE_PUNCH_SETTINGS_ID : 1,
	REPORT_SETTINGS_ID : 2,
	MEMBERSHIP_MANAGEMENT_ID: 3,
	ATTENDANCE_SETTINGS_ID : 4,
	LINE_MANAGER_SETTINGS_ID : 5,
	LOCATION_TRACKING_SETTINGS_GROUP_ID : 8,
	FISCAL_YEAR_SETTINGS_ID : 9,
	EMPLOYEE_DEVICE_LIMITS_ID : 10
}
